<template>
  <v-select
    :id="id"
    ref="albatrossSelect"
    :placeholder="placeholder"
    :model-value="value"
    :items="items"
    :chips="chips"
    :loading="loading"
    :item-title="itemTitle"
    :item-value="itemValue"
    :return-object="returnObject"
    :multiple="multiple"
    :prepend-icon="prependIcon"
    :prepend-inner-icon="prependInnerIcon"
    :append-icon="appendInnerIcon"
    :clearable="clearable"
    :menu-props="menuProps"
    v-bind="$attrs"
    :hint="hint"
    :single-line="singleLine"
    :rules="combinedRules"
    :readonly="readonly"
    :disabled="disabled"
    :hide-details="hideDetails"
    :density="density"
    :color="color"
    :no-data-text="noDataText"
    :clear-icon="clearIcon"
    :variant="variant"
    :persistent-hint="persistentHint"
    :class="[customClasses]"
    autocomplete="autocomplete"
    prepend-item
    :label="label"
  >
    <!--  do not change :slot to use v-slot here until we are in vue3..this is so dumb  -->
    <!--    <template v-for="(_, slot) in $slots" :slot="slot">-->
    <!--      <slot :name="slot"></slot>-->
    <!--    </template>-->

    <template
        v-for="(_, name) in $slots" v-slot:[name]="slotData" :key="name"
    >
      <slot
          :name="name"
          v-bind="slotData ?? {}"
      />
    </template>

    <!--    <template v-for="(index, name) in $scopedSlots" v-slot:[name]="data">-->
    <!--      <slot :name="name" v-bind="data"></slot>-->
    <!--    </template>-->
  </v-select>
</template>

<script setup>
import {ref, computed, getCurrentInstance} from 'vue'
import constants from '@/helpers/constants'
const instance = getCurrentInstance()

// reminder that v-model is sugar syntax for :value="value" @input="v => $emit('input', v)"
const basicRequiredRule = ref(constants.BASIC_REQUIRED_RULE)

const props = defineProps({
  id: String,
  value: [String, Number, Object, Array], //object for when return-object, array for when multiple
  items: {
    type: Array,
    default: () => []
  },
  // itemTitle: String, //vuetify3 = item-title, vuetify2 = item-text
  itemTitle: [String, Function], //vuetify3 = item-title, vuetify2 = item-text
  itemValue: String,
  noDataText: String,
  bgColor: String, //vuetify3 = bg-color, vuetify2 = background-color
  multiple: Boolean,
  returnObject: Boolean,
  loading: Boolean,
  placeholder: String, //fields without a defined default will default to null
  label: String,
  variant: String,
  hint: String,
  menuProps: String,
  color: String,
  clearIcon: String,
  prependIcon: String,
  prependInnerIcon: String,
  //vue2's appendIconOuter = appendIcon in vue3
  //vue2's appendIcon = appendInnerIcon in vue3
  appendIcon: String,
  appendInnerIcon: String,
  type: {
    type: String,
    default: 'text'
  },
  rules: {
    type: Array,
    default: () => []
  },
  customClasses: {
    type: String,
    default: ''
  },
  required: Boolean,
  readonly: Boolean,
  disabled: Boolean,
  clearable: Boolean,
  chips: Boolean,
  hideDetails: Boolean,
  singleLine: Boolean,
  persistentHint: Boolean,
  density: String,
  autocomplete: String
})

const variants = [
  'outlined',
  'plain',
  'underlined',
  'filled',
  'solo',
  'solo-inverted',
  'solo-filled'
]
const variant = computed(() => {
  if (!variants.includes(props.variant)) {
    return 'filled'
  }
  return props.variant
})

const albatrossSelect = ref(null)

const combinedRules = computed(() => {
  let tempRules = []
  //set the rules to any rules that were passed in
  tempRules = props.rules
  // if the field is marked as "required" also add the basic required rule
  if (props.required) {
    tempRules = tempRules.concat(basicRequiredRule.value)
  }
  return tempRules
})

const newFocus = () => {
  albatrossSelect.value.focus()
}

defineExpose({
  focus: newFocus
})
</script>

<style lang="scss" scoped></style>
